import React, { useState } from 'react';

import StarIcon from '@mui/icons-material/Star';
import { Box, Collapse, IconButton, Typography } from '@mui/material';
import Chunk from 'modules/Programs/components/Chunks';
import renderChunkContent from 'modules/Programs/utils/renderChunkContent';

import Description from '@common/components/Description';
import { IChunkModel } from '@common/models/Chunks/Chunk';
import { IGradeBookModel } from '@common/models/GradeBooks/GradeBook';

interface PropsType {
	topic: any;
	gradeBook: IGradeBookModel;
	disabled: boolean;
}

function Topic({ topic, gradeBook, disabled }: PropsType) {
	const [isCollapsed, setIsCollapsed] = useState(true);

	return (
		<Box
			sx={{
				display: 'flex',
				background: 'transparent',
				flexDirection: 'column',
				gap: '8px',
			}}
		>
			<Box
				sx={{
					background: '#FFFFFF',
					width: '100%',
					minHeight: '56px',
					borderRadius: '16px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					padding: '8px 16px',
					cursor: 'pointer',
					gap: '16px',
					scrollMarginTop: '16px',
				}}
				component="div"
				onClick={() => setIsCollapsed((prev) => !prev)}
			>
				<Typography component="h2" sx={{ fontSize: '16px', lineHeight: '24px', fontWeight: 400 }}>
					{topic.topic.name}
				</Typography>
				<IconButton size="large">
					<StarIcon />
				</IconButton>
			</Box>
			<Collapse in={!isCollapsed}>
				<Description html={topic.topic.description} />
				<Box>{renderChunkContent(topic.topic, gradeBook, disabled)}</Box>
				{topic.chunks.map((chunkModel: IChunkModel) => (
					<Chunk
						chunkModel={chunkModel}
						key={chunkModel?.id}
						hideTitle
						gradeBook={gradeBook}
						disabled={disabled}
					/>
				))}
			</Collapse>
		</Box>
	);
}

export default Topic;
